var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateGig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1006.8 1007.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "create-gig_svg__st0",
    d: "M134.1 732H871v138.7H134.1zM129.9 713.1L0 638.1l69.3-120 338.5 194.8zM75 498.1L0 368.2l120.1-69.3 195.6 337.9zM134.2 284.6v-150h138.7l.4 390.5zM293.4 129.9L368.4 0l120.1 69.3-194.9 338.5zM508.4 75L638.3 0l69.4 120.1-338 195.6zM722 134.3h150V273l-390.5.4zM876.9 712.5l129.9-75-69.4-120.1L599 712.3zM931.8 497.5l75-129.9-120.1-69.4-195.7 338zM301.1 891.5l66.9 116 199.8-116M608.4 891.5l-84.8 50 114.3 66 66.9-116z"
  })));
}

export default SvgCreateGig;